import React, {useEffect} from 'react';
import BuyBeltInit from '../../shims/buy-belt-init';
import "./instant-checkout.scss";

function InstantCheckout({
  fulfillmentDetails,
  selectedOption,
  shippingDetails
}) {

    useEffect(() => {
        BuyBeltInit.initICTooltip();
       }, []
    );
    const icModel = fulfillmentDetails.instantCheckoutModel || {};
    //console.log("InstantCheckout", icModel);

    const showInstantCheckout =
        fulfillmentDetails.isInstantCheckoutEligible && !fulfillmentDetails.isSubscriptionEligible;
    const isGuest = fulfillmentDetails.isGuest;
    const isB2CCustomer = fulfillmentDetails.isB2CCustomer;
    const hasSthItem = shippingDetails.enabled;

    if(showInstantCheckout && hasSthItem){
        if((isGuest || (icModel.displayOption && icModel.displayOption === "SIGN_IN") || (isB2CCustomer && icModel.displayOption ==="ENROLL"))){
            return (
                <div className="instant-checkout update-settings">
                    <div className="instant-checkout__wrapper">
                        <div className="grid">
                            <div className="col-12">
                                <span className="heading-message" id="placeToolTip">
                                    Your Fastest Checkout
                                    <a
                                        href="#"
                                        id="icInfoTooltipOpener"
                                        className="instant-checkout__tooltip-opener"
                                        style={{cursor: "pointer"}}
                                    >
                                        <span className="pip-icons info"></span>
                                    </a>
                                </span>
                            </div>
                            <div className="col-12">
                                <span>
                                    <a
                                        href="/account/view/instantcheckout"
                                        className="instant-checkout__link"
                                    >
                                            Turn on Instant Checkout
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }else if(!isGuest && icModel.displayOption && icModel.displayOption === "EDIT_IC"){
            return (
                <div className="instant-checkout update-settings">
                    <div className="instant-checkout__wrapper">
                        <div className="grid">
                            <div className="col-12">
                                <span className="heading-message" id="placeToolTip">
                                    Your Fastest Checkout
                                    <a
                                        href="#"
                                        id="icInfoTooltipOpener"
                                        className="instant-checkout__tooltip-opener"
                                        style={{cursor: "pointer"}}
                                    >
                                        <span className="pip-icons info"></span>
                                    </a>
                                </span>
                            </div>
                            <div className="col-12">
                                <span>
                                    <a
                                        href="/account/view/instantcheckout"
                                        className="instant-checkout__link"
                                    >
                                            Update Instant Checkout Settings
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if(!isGuest && icModel.addressZipCode && icModel.displayCardBrand){
            return (
                <div className="instant-checkout">
                    <div className="instant-checkout__wrapper">
                            <div className="">
                                <button
                                    disabled={selectedOption!=="STH"}
                                    className={"bttn-outline bttn-outline--primary atc_instant_checkout " + (selectedOption!=="STH"? "disabled":"")}
                                    id="atc_instant_checkout">
                                    <span className="bttn__content"> Instant Checkout</span>
                                </button>
                            </div>
                            {selectedOption==="STH" &&
                            <div className="no-justify-center instant-checkout-details">
                                <nobr>Deliver to:&nbsp;
                                    <a href="/account/view/instantcheckout" className="instant-checkout__link u__default-link">{icModel.addressZipCode}</a>&nbsp;|&nbsp;
                                </nobr>
                                <span>
                                    <a href="/account/view/instantcheckout" className="instant-checkout__link u__default-link">{icModel.displayCardBrand}&nbsp;••{icModel.xref}</a>
                                </span>
                            </div>}
                    </div>
                </div>
            );
        } else{
            return null;
        }
    }else{
        return null;
    }
}

export default InstantCheckout;
